/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { TVisit } from "apis/visitors/type";
import { theme } from "styles/theme";
import Button from "uis/Button";
import { getKorDate, getKorTime } from "utils/date";
import StateTag from "../state-tag";

const ItemContainer = styled.div`
  display: flex;
  padding: 16px 24px;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid ${theme.neutral100};
`;

const WidgetContainer = styled.div<{ width: number }>`
  width: ${(props) => props.width + "px"};
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.neutral900};
`;

const DateItem = styled.p`
  color: ${theme.neutral500};
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  width: max-content;
`;

export const Item = ({ record, onClick }: { record: TVisit; onClick?: (record: TVisit) => void }) => {
  const owner = record.visitRecordManagers.find((manager) => manager.isOrganizer);

  return (
    <ItemContainer>
      {record.visitors[0]?.name ? (
        <WidgetContainer width={150}>
          {record.visitors[0].name}
          {record.visitors.length > 1 && `외 ${record.visitors.length - 1}명`}
        </WidgetContainer>
      ) : (
        <WidgetContainer
          width={150}
          css={css`
            color: ${theme.neutral400};
          `}
        >
          개인정보 수집 미동의
        </WidgetContainer>
      )}
      <WidgetContainer width={150}>{record.visitorDepartment}</WidgetContainer>
      <WidgetContainer width={150}>
        <DateItem>
          {getKorDate(record.visitDatetime)}
          <br />
          {getKorTime(record.visitDatetime)}
        </DateItem>
      </WidgetContainer>
      <WidgetContainer width={100}>{owner?.manager.nickname}</WidgetContainer>
      <WidgetContainer width={100}>
        <StateTag state={record.visitRecordStatus} />
      </WidgetContainer>
      <Button
        onClick={() => {
          onClick?.(record);
        }}
        title="더보기"
        type="secondary"
        styles={{
          container: css`
            margin-left: auto;
            padding: 12px 20px;
          `,
          text: css`
            font-size: 14px;
          `,
        }}
      />
    </ItemContainer>
  );
};

export default Item;
